import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';
import { Loading, NetworkError } from 'owa-interstitial';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "HybridspaceAdminRoute" */ './lazyIndex'),
    { name: 'HybridspaceAdminRoute' }
);

export const AdminAnalyticsScreen: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.AdminAnalyticsScreen,
    Loading,
    NetworkError
);

export const AdminManagementScreen: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.AdminManagementScreen,
    Loading,
    NetworkError
);
